<template>
    <modal @close="$emit('close')">
        <div class="mx-12 flex text-center flex-col">
            <div class="flex flex-wrap">
                <p class="text-brand-light font-semibold">Имя капитана</p>
                <p>, ваши изменения </p></div>
            <p>будут внесены.<br>
                <br>
                Наш администратор свяжется<br>
                с вами для подтверждения информации.<br>
                <br>
            </p>
            <p class="text-brand-light font-semibold">Спасибо!</p>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'save',
  components: { Modal },
  props: ['save'],
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
    };
  },

};

</script>

<style scoped>
</style>
